export default __webpack_public_path__ + "static/media/logo.afd965fe.png";